import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useOptInDialogStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContent: {
            paddingLeft: theme.spacing(14),
            paddingRight: theme.spacing(13),
        },
        image: {
            margin: theme.spacing(0, 2, 6, 2),
        },
        description: {
            margin: theme.spacing(0, 5),
            marginTop: theme.spacing(6),
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '458px',
        },
        title: {
            whiteSpace: 'pre-line',
            marginTop: theme.spacing(3),
        },
    }),
);

export default useOptInDialogStyles;
